// @mui
//

// ----------------------------------------------------------------------

export interface CustomRadiusOptions {
  xs: '2px'
  small: '4px'
  medium: '8px'
  large: '16px'
  oval: '999px'
}

// ----------------------------------------------------------------------

export default function customRadius() {
  return {
    xs: '2px',
    small: '4px',
    medium: '8px',
    large: '16px',
    oval: '999px',
  } as CustomRadiusOptions
}
